module.exports = __webpack_public_path__ + "static/media/campaign.4ecefe53.png";